module.exports = __webpack_public_path__ + "static/media/loading_spinner.9f9b709e.svg";